import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RendererDirective } from '../../core/dynamic/renderer';
import { ViewSignal } from '../../signal';

@Component({
    selector: 'app-foot',
    imports: [CommonModule, RendererDirective],
    templateUrl: './foot.component.html',
    styleUrls: ['./foot.component.scss']
})
export class FootComponent {
    private readonly viewSignal = inject(ViewSignal);

    foot = computed(() => this.viewSignal.foot());
}
